import { ITemplate } from '@/states/organization-template.state';
import OrgChartTree from './OrgChartTree';
import { RawNodeDatum } from 'react-d3-tree';

interface TemplateCardProps {
  template: ITemplate;
  treeData?: RawNodeDatum | null;
  onClick: () => void;
  isLoading?: boolean;
}

export default function TemplateCard({ template, treeData, onClick, isLoading }: TemplateCardProps) {
  const validTreeData = treeData && typeof treeData === 'object' ? [treeData] : [];

  return (
    <div
      onClick={onClick}
      className="border rounded-xl p-4 cursor-pointer hover:border-primary hover:shadow-md transition-all bg-white group h-full flex flex-col"
    >
      <div className="w-full h-48 bg-gray-50 rounded-lg mb-4 relative overflow-hidden border border-gray-100">
        {isLoading ? (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          </div>
        ) : validTreeData.length > 0 ? (
          <div className="w-full h-full pointer-events-none select-none">
            {/* Use a wrapper to scale down the chart if necessary, though OrgChartTree has zoom */}
            <div className="transform scale-[0.6] origin-top-center h-[166%] w-[166%] -ml-[33%] -mt-[10%]">
              <OrgChartTree
                isLoading={false}
                treeData={validTreeData}
                onSelect={() => undefined} // No-op, handled by card click
                viewMode="diagram"
                // Hide actions by not passing them
              />
            </div>
          </div>
        ) : template.preview_image_url ? (
          <img
            src={template.preview_image_url}
            alt={template.name}
            className="w-full h-full object-contain p-2 group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="text-gray-300 flex flex-col items-center justify-center h-full gap-2">
            <span className="text-sm">No Preview</span>
          </div>
        )}
      </div>
      <h3 className="font-semibold text-slate-700 text-center group-hover:text-primary transition-colors mt-auto">
        {template.name}
      </h3>
    </div>
  );
}
